import { Box, Grid, Typography } from "@mui/material";

const Preview1 = ({ fieldValues, selectedColor, fullHeight=false, page='preview', sections}) => {
  let headerFontSize ='30px',subHeaderFontSize ='16px', headerPadding = 5, contentpadding = 3,subContentPadding = 1, titleFontSize = '18px', subTitleFontSize='16px', contentFontSize = '14px';
    if(page === 'template'){
        headerFontSize = '16px'
        subHeaderFontSize = '10px'
        headerPadding = 2
        contentpadding = 1
        subContentPadding = 0.5
        titleFontSize = '12px'
        subTitleFontSize = '10px'
        contentFontSize = '10px'
    }
  
  const getexperienceContent = () =>{
      return <><Box sx={{ padding: contentpadding, backgroundColor: selectedColor?.[1] || "#B8F19D" }}>
            <Typography sx={{ fontSize: titleFontSize, color: selectedColor?.[2] || '#000', fontWeight: 600 }}>Work History</Typography>
          </Box>
          <Box p={contentpadding}>
             {fieldValues.experience.map((exp, index) => {
                return (
                  <Box key={index}>
                    <Box sx={{display: "flex", alignItems: "center",justifyContent: "space-between"}}>
                      <Box>
                        <Typography sx={{fontSize: subTitleFontSize, color: '#000', fontWeight: 600,wordBreak: "break-word"}}>
                          {exp.job_title}
                        </Typography>
                        <Typography component="p" sx={{fontStyle: "italic",color:  '#000',fontSize: contentFontSize,wordBreak: "break-word"}}>
                          {exp.employer}
                        </Typography>
                      </Box>
                      <Box flexShrink={0}>
                        <Typography sx={{fontSize: contentFontSize,color: '#000',fontStyle: "italic"}}>
                          {exp.start_date[1]} {exp.start_date[0]} -{" "}
                          {exp.end_date[1]} {exp.end_date[0]}
                        </Typography>
                      </Box>
                    </Box>
                    <Box p={subContentPadding}>
                      {exp.description ? (
                        <Typography sx={{ fontSize: contentFontSize, color: '#000'}} dangerouslySetInnerHTML={{__html: exp.description?._cache?.html ? exp.description?._cache?.html.toString('html') : exp.description.toString('html')}}></Typography>
                      ) : (
                        ""
                      )}
                    </Box>
                  </Box>
                );
              })}
          </Box></>
  }

  const geteducationContent = () =>{
      return <><Box sx={{ padding: contentpadding, backgroundColor: selectedColor?.[1] || "#B8F19D" }}>
            <Typography sx={{ fontSize: titleFontSize, color: selectedColor?.[2] || '#000', fontWeight: 600 }}>Education</Typography>
          </Box>
          <Box p={contentpadding}>
            {fieldValues.education.map((edu, index) => {
                return (
                  <Box key={index}>
                   <Box sx={{display: "flex", alignItems: "center",justifyContent: "space-between"}}>
                      <Box>
                      <Typography sx={{fontSize: subTitleFontSize, color: '#000', fontWeight: 600,wordBreak: "break-word"}}>
                          {edu.degree}{" "}
                          {edu.field_of_study.length > 0
                            ? `- ${edu.field_of_study}`
                            : ""}
                        </Typography>
                        <Typography component="p" sx={{fontStyle: "italic",color:  '#000',fontSize: contentFontSize,wordBreak: "break-word"}}>
                          {edu.school_name}, {edu.school_location}
                        </Typography>
                      </Box>
                      <Box sx={{ flexShrink: 0 }}>
                      <Typography sx={{fontSize: contentFontSize,color: '#000',fontStyle: "italic"}}>
                          {edu.start_date[0]}{" "}
                          {edu.end_date[0] ? `- ${edu.end_date[0]}` : ""}{" "}
                        </Typography>
                      </Box>
                    </Box>
                  </Box>
                );
              })}
          </Box></>
  }

  const getskillsContent = () =>{
    return <><Box padding="20px">
    <Typography sx={{fontStyle: "italic",color: selectedColor?.[2] || '#000',fontSize: titleFontSize,wordBreak: "break-word", fontWeight: 600}}>
      Skills
    </Typography>
    <Box
      sx={{
        color: selectedColor?.[2] || '#000'
      }}
    >
       {fieldValues.skills.map((skill, index) => {
          return (
            <Typography key={index} wordBreak="break-word" fontSize={contentFontSize}>
              {skill.skill}
            </Typography>
          );
        })}
    </Box>
  </Box></>
  }
  
  const getotherContent = () =>{
    return <Box>
    {fieldValues.other[0].title ? fieldValues.other.map((other, index) => {
         return (
           <Box padding="20px" key={index}>
             {other.title ? (
               <Typography sx={{fontStyle: "italic",color:  '#000',fontSize: titleFontSize,wordBreak: "break-word", fontWeight: 600}}> 
                 {other.title}
               </Typography>
             ) : (
               ""
             )}
             {other.content ? (
               <Typography
                 sx={{fontSize: contentFontSize}}
                 dangerouslySetInnerHTML={{__html: other.content?._cache?.html ? other.content?._cache?.html.toString('html') : other.content.toString('html')}}
               ></Typography>
             ) : ("")}
           </Box>
         )
       }) : ''}    
 </Box>
}

  
  return (
    <Box sx={{ boxShadow: "rgba(0, 0, 0, 0.35) 0px 5px 15px", flexGrow: 1, display:"flex", width:"100%",  height: fullHeight ? "100%" : 'auto'  }} >
      <Grid container flexGrow={1}>
        <Grid item xs={8}>
          <Box p={headerPadding} sx={{ backgroundColor: selectedColor?.[0] || "#B8F19D"}}
          >
            <Typography sx={{ fontSize: headerFontSize, color: selectedColor?.[2] || '#000', fontWeight: 600 }}>
              {fieldValues.f_name || "John"} {fieldValues.l_name}
            </Typography>
          </Box>
          {fieldValues.objective ? <Box p={contentpadding}>
            <Typography sx={{ color: '#000', fontSize: contentFontSize }}>
              {fieldValues.objective}
            </Typography>
          </Box> : ""}

          {sections?.map((section)=>{
                    if(section === 'Education'){
                        return fieldValues.education.length ? geteducationContent() : ''
                    }else if(section === 'Experience'){
                        return fieldValues.experience.length ? getexperienceContent() : ''
                    }
                    return ''
                })
            }
        </Grid>
        <Grid item xs={4} sx={{ backgroundColor: selectedColor?.[1] || "#385718" }}>
          <Box sx={{ padding: "20px", color:selectedColor?.[2] || '#000' }}>
            <Typography sx={{ fontSize: subHeaderFontSize }}>
              {fieldValues.city || "City"} , {fieldValues.state || "State"}
            </Typography>
            <Typography sx={{ fontSize: subHeaderFontSize }}>
              {fieldValues.email || "xxx@gmail.com"}
            </Typography>
            <Typography sx={{ fontSize: subHeaderFontSize }}>
              {fieldValues.phone || "Phone Number"}
            </Typography>
          </Box>
          {sections?.map((section)=>{
                    if(section === 'Skills'){
                        return fieldValues.skills.length ? getskillsContent() : ''
                    }else if(section === 'Other'){
                        return fieldValues.other.length && fieldValues.other[0].title ? getotherContent() : ''
                    }
                    return ''
                })
            }
        </Grid>
      </Grid>
    </Box>
  );
};

export default Preview1;
